var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoldOutWithText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 158,
    viewBox: "0 0 119 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_211",
    x: 2,
    y: 0,
    width: 117,
    height: 115,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_2756",
    x: 0,
    y: 109,
    width: 117,
    height: 49,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83096",
    "data-name": "Group 83096",
    transform: "translate(7.013 5.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12694",
    "data-name": "Group 12694",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.01, -5.39)",
    filter: "url(#Ellipse_211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_211-2",
    "data-name": "Ellipse 211",
    transform: "translate(7 5)",
    fill: "#ffc629",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5,
    cy: 51.5,
    rx: 52.5,
    ry: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.5,
    cy: 51.5,
    rx: 51,
    ry: 50,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6735",
    "data-name": "Group 6735",
    transform: "translate(28.873 13.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4566",
    "data-name": "Group 4566",
    transform: "translate(8.81 24.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4557",
    "data-name": "Group 4557",
    transform: "translate(1.468 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M58.215,93.7,45,100.456V52H71.431v48.456Z",
    transform: "translate(-45 -52)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4558",
    "data-name": "Group 4558",
    transform: "translate(22.025 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M64.873,52v48.456l-5.873-3V52Z",
    transform: "translate(-59 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(1.468 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M45,52v48.456l5.873-3V52Z",
    transform: "translate(-45 -52)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4560",
    "data-name": "Group 4560",
    transform: "translate(7.342 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M49,52V73.148l2.806-.678,4.536,3.024,4.537-3.023,2.8.677V52Z",
    transform: "translate(-49 -52)",
    fill: "#2758a8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4561",
    "data-name": "Group 4561",
    transform: "translate(22.025 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M59,52V73.148l2.773.67,2.8-4.24.3-.027V52Z",
    transform: "translate(-59 -52)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4562",
    "data-name": "Group 4562",
    transform: "translate(1.468 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M45,52V69.55l.3.027,2.8,4.24,2.773-.67V52Z",
    transform: "translate(-45 -52)",
    fill: "#ccdcff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4563",
    "data-name": "Group 4563",
    transform: "translate(20.557)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M65.342,102.393a1.467,1.467,0,0,1-.668-.16l-5.873-3a1.47,1.47,0,0,1-.8-1.308V52.468A1.468,1.468,0,0,1,59.468,51h5.873a1.468,1.468,0,0,1,1.468,1.468v48.456a1.468,1.468,0,0,1-1.468,1.468Zm-4.405-5.368,2.937,1.5V53.937H60.937Z",
    transform: "translate(-58 -51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564",
    transform: "translate(5.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M49.468,95.051A1.468,1.468,0,0,1,48,93.583V52.468a1.468,1.468,0,0,1,2.937,0V93.583A1.468,1.468,0,0,1,49.468,95.051Z",
    transform: "translate(-48 -51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4565",
    "data-name": "Group 4565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M71.9,102.393a1.468,1.468,0,0,1-.668-.16L58.684,95.819l-12.547,6.414A1.469,1.469,0,0,1,44,100.924V77.431a1.468,1.468,0,0,1,2.937,0V98.525l11.079-5.662a1.46,1.46,0,0,1,1.336,0l11.079,5.662V53.937H46.937V73.025a1.468,1.468,0,0,1-2.937,0V52.468A1.469,1.469,0,0,1,45.468,51H71.9a1.468,1.468,0,0,1,1.468,1.468v48.456a1.468,1.468,0,0,1-1.468,1.468Z",
    transform: "translate(-44 -51)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4571",
    "data-name": "Group 4571",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4567",
    "data-name": "Group 4567",
    transform: "translate(1.468 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M80.028,60.8l3.023-3.778-3.023-3.781L81.373,48.6l-4.239-2.337L76.6,41.451l-4.812-.536-2.333-4.239-4.649,1.345L61.025,35l-3.778,3.023L52.6,36.676l-2.334,4.239-4.812.536-.534,4.808L40.676,48.6l1.347,4.647L39,57.025,42.023,60.8l-1.346,4.65,4.238,2.333.536,4.812,4.808.535,2.337,4.24,4.65-1.348,3.78,3.024,3.781-3.023,4.647,1.346,2.337-4.24L76.6,72.6l.536-4.811,4.237-2.335Z",
    transform: "translate(-39 -35)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4568",
    "data-name": "Group 4568",
    transform: "translate(30.427 3.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M73.814,56.491l-3.023-3.781,1.345-4.647L67.9,45.725l-.535-4.808L62.55,40.38l-2.333-4.239-1.5.433L60.4,40.38l3.85.536.427,4.808,3.391,2.337-1.075,4.647,2.418,3.781-2.418,3.778,1.075,4.65-3.39,2.335-.429,4.811L60.4,72.6l-1.679,3.807,1.5.433,2.337-4.24,4.808-.535.536-4.811,4.237-2.335-1.345-4.65Z",
    transform: "translate(-58.722 -36.142)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4569",
    "data-name": "Group 4569",
    transform: "translate(1.468 3.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M48.566,72.065l-.429-4.812L44.746,64.92l1.078-4.65-2.418-3.778,2.419-3.781-1.078-4.647,3.393-2.337.427-4.808,3.849-.536,1.677-3.806-1.5-.433L50.263,40.38l-4.812.536-.534,4.808-4.24,2.337,1.347,4.647L39,56.491l3.023,3.778-1.346,4.65,4.238,2.333.536,4.812,4.808.535L52.6,76.84l1.495-.433L52.412,72.6Z",
    transform: "translate(-39 -36.142)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4570",
    "data-name": "Group 4570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M61.494,80.987a1.469,1.469,0,0,1-.918-.322l-3.185-2.549-3.918,1.137a1.476,1.476,0,0,1-1.7-.7l-1.969-3.574-4.051-.449a1.471,1.471,0,0,1-1.3-1.3l-.452-4.056-3.571-1.966a1.469,1.469,0,0,1-.7-1.695l1.135-3.919-2.548-3.183a1.47,1.47,0,0,1,0-1.835l2.548-3.186-.043-.148a1.468,1.468,0,0,1,2.821-.818l.255.88a1.472,1.472,0,0,1-.264,1.326l-2.291,2.865,2.289,2.862a1.47,1.47,0,0,1,.264,1.326L42.882,65.2l3.208,1.766a1.463,1.463,0,0,1,.75,1.125l.407,3.644,3.642.405a1.467,1.467,0,0,1,1.123.75l1.771,3.211L57.3,75.083a1.468,1.468,0,0,1,1.326.264l2.863,2.292,2.865-2.291a1.467,1.467,0,0,1,1.326-.264l3.52,1.022,1.769-3.213a1.467,1.467,0,0,1,1.125-.75l3.64-.405.407-3.643a1.467,1.467,0,0,1,.75-1.125l3.21-1.768L79.085,61.68a1.476,1.476,0,0,1,.264-1.324l2.291-2.862-2.291-2.865a1.473,1.473,0,0,1-.264-1.324l1.021-3.52-3.211-1.772a1.462,1.462,0,0,1-.75-1.123l-.405-3.64-3.645-.407a1.47,1.47,0,0,1-1.125-.75L69.2,38.882,65.683,39.9a1.471,1.471,0,0,1-1.326-.263l-2.863-2.289-2.862,2.289a1.476,1.476,0,0,1-1.326.264l-3.521-1.019-1.768,3.21a1.468,1.468,0,0,1-1.123.75l-3.644.407-.405,3.64a1.467,1.467,0,0,1-.75,1.125l-4.239,2.338a1.469,1.469,0,0,1-1.418-2.573l3.574-1.971.449-4.051a1.468,1.468,0,0,1,1.3-1.3l4.056-.452,1.968-3.573a1.466,1.466,0,0,1,1.694-.7l3.919,1.135,3.183-2.548a1.472,1.472,0,0,1,1.835,0L65.6,36.868l3.918-1.134a1.465,1.465,0,0,1,1.694.7l1.966,3.573,4.056.452a1.469,1.469,0,0,1,1.3,1.3l.449,4.051,3.573,1.971a1.468,1.468,0,0,1,.7,1.695L82.119,53.39l2.548,3.186a1.47,1.47,0,0,1,0,1.835l-2.548,3.183,1.134,3.919a1.469,1.469,0,0,1-.7,1.695l-3.571,1.968-.451,4.054a1.471,1.471,0,0,1-1.3,1.3l-4.051.449-1.971,3.574a1.471,1.471,0,0,1-1.694.7L65.6,78.118l-3.186,2.548A1.469,1.469,0,0,1,61.494,80.987Z",
    transform: "translate(-38 -34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4577",
    "data-name": "Group 4577",
    transform: "translate(8.81 8.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4572",
    "data-name": "Group 4572",
    transform: "translate(1.116 0.433)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 13.228,
    cy: 13.228,
    r: 13.228,
    transform: "translate(0 0)",
    fill: "#ffc629"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4573",
    "data-name": "Group 4573",
    transform: "translate(13.215 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M54.468,41A13.477,13.477,0,0,0,53,41.087a13.21,13.21,0,0,1,0,26.257A13.213,13.213,0,1,0,54.468,41Z",
    transform: "translate(-53 -41)",
    fill: "#ffa92c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4574",
    "data-name": "Group 4574",
    transform: "translate(1.468 1.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M47.937,54.215A13.211,13.211,0,0,1,59.684,41.087,13.478,13.478,0,0,0,58.215,41a13.215,13.215,0,1,0,1.468,26.344A13.211,13.211,0,0,1,47.937,54.215Z",
    transform: "translate(-45 -41)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4575",
    "data-name": "Group 4575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M58.684,69.367A14.7,14.7,0,0,1,44,54.684a14.865,14.865,0,0,1,.248-2.7,1.469,1.469,0,1,1,2.888.534,11.748,11.748,0,1,0,11.547-9.581,11.637,11.637,0,0,0-7.111,2.4A1.468,1.468,0,1,1,49.793,43a14.549,14.549,0,0,1,8.891-3,14.684,14.684,0,0,1,0,29.367Z",
    transform: "translate(-44 -40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4576",
    "data-name": "Group 4576",
    transform: "translate(1.553 5.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_314",
    "data-name": "Path 314",
    d: "M46.525,48.206a1.468,1.468,0,0,1-1.294-2.161,14.538,14.538,0,0,1,1.107-1.759,1.468,1.468,0,1,1,2.367,1.737,11.94,11.94,0,0,0-.885,1.407A1.467,1.467,0,0,1,46.525,48.206Z",
    transform: "translate(-45.058 -43.685)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12695",
    "data-name": "Group 12695",
    transform: "translate(0 109.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7.01, -114.39)",
    filter: "url(#Rectangle_2756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2756-2",
    "data-name": "Rectangle 2756",
    transform: "translate(7 114)",
    fill: "#ffc629",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 37,
    rx: 18.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 102,
    height: 34,
    rx: 17,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "SOLD_",
    "data-name": "SOLD!",
    transform: "translate(79.987 24.608)",
    fontSize: 18,
    fontFamily: "Outfit-Bold, Outfit",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -53.928,
    y: 0
  }, "SOLD!"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldOutWithText);
export default __webpack_public_path__ + "static/media/sold_out_with_text.bed55d6211dfa4554943b9054cd04b57.svg";
export { ForwardRef as ReactComponent };